module.exports = __webpack_public_path__ + "img/embedded5.d1c2da85.png";